/**
 * GDPR-compliant localStorage utilities
 */
import { hasConsentForCategory } from './cookieConsent';

/**
 * Set localStorage item with consent check
 * @param {string} key - Storage key
 * @param {string} value - Storage value
 * @param {string} category - Consent category (functional, analytics, etc.)
 */
export function setStorageItem(key, value, category = 'functional') {
  if (!hasConsentForCategory(category)) {
    console.warn(`Storage access denied for ${key} - no consent for ${category}`);
    return false;
  }
  
  try {
    localStorage.setItem(key, value);
    return true;
  } catch (error) {
    console.error('Failed to set storage item:', error);
    return false;
  }
}

/**
 * Get localStorage item (no consent check needed for reading)
 * @param {string} key - Storage key
 * @returns {string|null} - Storage value or null
 */
export function getStorageItem(key) {
  try {
    return localStorage.getItem(key);
  } catch (error) {
    console.error('Failed to get storage item:', error);
    return null;
  }
}

/**
 * Remove localStorage item
 * @param {string} key - Storage key
 */
export function removeStorageItem(key) {
  try {
    localStorage.removeItem(key);
    return true;
  } catch (error) {
    console.error('Failed to remove storage item:', error);
    return false;
  }
}

/**
 * Set language preference with consent check
 * @param {string} language - Language code
 */
export function setLanguagePreference(language) {
  return setStorageItem('language', language, 'functional');
}

/**
 * Get language preference
 * @returns {string|null} - Language code or null
 */
export function getLanguagePreference() {
  return getStorageItem('language');
}